import BaseRepository from '.'

export default class DebtConsolidationStatesCitiesRepository extends BaseRepository {
  static contentType = 'wwwDebtConsolidationStatesCities'

  defaultOrder = 'fields.city'

  async fillCities(model, preview) {
    const data = await this.getModels(
      {
        'fields.state': model?.state,
        select: 'fields.state,fields.city,fields.slug',
      },
      preview
    )

    const state = data.find((item) => !item.city)
    const cities = data.filter((item) => item.city)

    return {
      ...model,
      isState: !model.city,
      state: state || null,
      cities,
    }
  }
}
